import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const liveBuildAudioBridgeEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("live"),
		name: Type.Literal("audio bridge"),
		time: Type.Date(),
		details: Type.Object({
			success: Type.Boolean(),
		}),
	}),
);

const liveProctorJoinedEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("live"),
		name: Type.Literal("proctor joined"),
		time: Type.Date(),
		details: Type.Object({
			proctorId: Type.String(),
			count: Type.Optional(Type.Number()),
		}),
	}),
);

const liveProctorLeftEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("live"),
		name: Type.Literal("proctor left"),
		time: Type.Date(),
		details: Type.Object({
			proctorId: Type.String(),
			count: Type.Optional(Type.Number()),
		}),
	}),
);

const liveJoinSessionEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("live"),
		name: Type.Literal("join session"),
		time: Type.Date(),
		details: Type.Object({
			liveSessionId: Type.String(),
			liveUserSessionId: Type.String(),
			proctorIds: Type.Optional(Type.Array(Type.String())),
			proctorGroupIds: Type.Optional(Type.Array(Type.Number())),
		}),
	}),
);

const noProctorsEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("live"),
		name: Type.Literal("no proctors"),
		time: Type.Date(),
		details: Type.Object({
			isOnJoin: Type.Boolean(),
		}),
	}),
);

export default {
	liveBuildAudioBridgeEvent,
	liveProctorJoinedEvent,
	liveProctorLeftEvent,
	liveJoinSessionEvent,
	noProctorsEvent,
};
